var map = {
	"./music-instructions.json": 4711,
	"./music-library-intro2024.json": 4712,
	"./music-library-launch2024.json": 4713,
	"./music-progression.json": 4714,
	"./startSourcesAdvanced.json": 4715,
	"./startSourcesSimple.json": 4716,
	"./startSourcesSimple2.json": 4717,
	"./startSourcesTracks.json": 4718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4479;